import { useRef } from 'react';

import { motion, useInView, useReducedMotion } from 'framer-motion';
import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';

import { ZUIDivider } from './MotionDivider.style';

const Divider = motion.create(ZUIDivider);

function MotionDivider({ height = 2 }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true });
  const prefersReducedMotion = useReducedMotion();

  const animateProps = prefersReducedMotion
    ? { scaleX: 1, translateX: '0' }
    : { scaleX: isInView ? 1 : 0, translateX: '0' };

  const initialProps = prefersReducedMotion
    ? { scaleX: 1, translateX: '0' }
    : { scaleX: 0, translateX: '-100%' };

  const transition = prefersReducedMotion
    ? { duration: 0, ease: 'linear' }
    : { duration: 0.4, ease: [0.4, 0, 0.2, 1] };

  return (
    <Box>
      <Divider
        ref={ref}
        animate={animateProps}
        exit={prefersReducedMotion ? undefined : { scaleX: 0, translateX: '-100%' }}
        height={height}
        initial={initialProps}
        style={{
          transformOrigin: 'left'
        }}
        transition={transition}
      />
    </Box>
  );
}

MotionDivider.propTypes = {
  height: PropTypes.number
};

export default MotionDivider;
